// @ts-nocheck

import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import type { RouterHistory } from 'react-router-dom';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import type { GridState } from '../../types';
import type { CopyGridType } from '../../types/actions';

import Secondary from './Secondary';

const Wrap = styled(Secondary)``;

type GridsCopyGridButtonProps = {
  className?: string;
  isVisible: boolean;
  copyGrid: CopyGridType;
  grid: GridState;
  history: RouterHistory;
  redirectLink: string;
};

const GridsCopyGridButton = ({ isVisible, className, copyGrid, grid, redirectLink }: GridsCopyGridButtonProps) => {
  const history = useHistory();

  const handleClick = useCallback(() => {
    copyGrid(grid);
    history.push(redirectLink);
  }, [copyGrid, grid, history, redirectLink]);

  return isVisible ? (
    <Wrap className={className} onClick={handleClick}>
      {__('Copy')}
    </Wrap>
  ) : null;
};

export default GridsCopyGridButton;
